// extracted by mini-css-extract-plugin
export default {"box":"Accordions_box__eplBw","hover":"Accordions_hover__rA4pK"};